<template>
  <version-card title="应用更新">
    <detect-updates :data="updateList"></detect-updates>
    <div class="public-title">近30天升级记录</div>
    <version-record :services="services" />
    <div class="height128"></div>
  </version-card>
</template>

<script>
import Card from "@/components/dashboard/devops/version/card.vue";
import Updates from "@/components/dashboard/devops/version/detect-updates.vue";
import versionRecord from "@/components/dashboard/devops/version/overview/record.vue";
import { ref } from "vue";
export default {
  name: "system-update-info",
  components: {
    [Card.name]: Card,
    [Updates.name]: Updates,
    [versionRecord.name]: versionRecord
  },
  setup() {
    const updateList = ref([
      {
        name: "云启 v1.2.1",
        adopt: 1,
        value: "a"
      },
      {
        name: "招商云 v2.2.1",
        adopt: 2,
        value: "b"
      },
      {
        name: "环境与健康管理 v1.0.1",
        adopt: 1,
        value: "c"
      },
      {
        name: "碳中和平台 v1.0.1",
        value: "d"
      }
    ]);
    const services = ref([
      {
        key: "1",
        src: require("@/assets/img/devops/service5.jpg"),
        title: "智慧办公",
        version: "1.2.0",
        updateTime: "2022/02/26  09:20:17",
        typeName: "应用"
      },
      {
        key: "2",
        src: require("@/assets/img/devops/service2.png"),
        title: "ABAS",
        version: "1.2.0",
        updateTime: "2022/03/31  09:19:52",
        typeName: "应用"
      }
    ]);
    return { updateList, services };
  }
};
</script>
<style scoped lang="less">
.public-title {
  margin: 24px 0 16px;
}
</style>
